import producer from "immer";

const INITIAL_STATE = {
	requests: [],
};

export default function analytics(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@analytics/SAVE_EVENT": (draft) => {
			draft.requests = action.payload.requests;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
